import React from 'react'
import Checklist from './checklist'
import Fallback from './fallback'

export default ({ checklists }) => <div>
  {checklists.map((c, i) => <Checklist data={c} key={i} n={i + 1} />)}
  {checklists.length === 0 && <Fallback />}
</div>


// WEBPACK FOOTER //
// ./src/components/checklistCollection.js